<p *ngIf="!onlineOffline" style="top:50%;position: absolute;left: 5%;">Check your network connection...!trying to reconnect in..{{refreshTime}}</p>
